import './messaging_init.ts';
import React, { useEffect } from 'react';
import { OidcAuth, OnboardingTourProvider } from './components';
import { setLightTheme, theme } from './theme';
import { ChakraProvider } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { PUBLIC_ROUTES_PATHS, PublicRoutes } from './PublicRoutes';
import { NuqsAdapter } from 'nuqs/adapters/react';
import { AppRoutes } from './routes/AppRoutes';

const App = () => {
	const loc = useLocation();
	useEffect(() => {
		setLightTheme();
		window.addEventListener('vite:preloadError', _event => {
			window.location.reload();
		});
	}, []);

	if (
		loc.pathname === PUBLIC_ROUTES_PATHS.PP ||
		loc.pathname === PUBLIC_ROUTES_PATHS.TOS ||
		loc.pathname === PUBLIC_ROUTES_PATHS.STR
	) {
		return (
			<ChakraProvider theme={theme}>
				<PublicRoutes />
			</ChakraProvider>
		);
	}
	return (
		<ChakraProvider theme={theme}>
			<NuqsAdapter>
				<OidcAuth>
					<OnboardingTourProvider>
						<AppRoutes />
					</OnboardingTourProvider>
				</OidcAuth>
			</NuqsAdapter>
		</ChakraProvider>
	);
};

export default App;
